import { Table, TableCell, TableContainer, TableHead } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { theme } from '../../../theme';
import StaffReviewItemEntry from './StaffReviewItemEntry';

function StaffReviewChangesOnlyView(props) {
    const [selectedItem, setSelectedItem] = useState(null);

    const combinedChanges = useMemo(() => {
        const combined = [];

        Object.keys(props.review.recommendations ?? {}).forEach((category) => {
            combined.push(...props.review.recommendations[category].filter((rec) => {
                const review = props.variant === 'implementer' ? rec.implementer_review : rec.clinical_review;
                if (review?.status === 'closed') return false;

                if (props.review.status === 'implemented') {
                    return rec.clinical_review !== null || rec.implementer_review !== null;
                }

                if (props.variant === 'implementer' && props.review.status === 'applied') {
                    return rec.implementer_review !== null;
                } 
                return rec.clinical_review !== null;
            }));
        });

        return combined;
    }, [props.review]);

    function isRecReadOnly(rec) {
        return props.isReadOnly || 
            (props.variant === 'implementer' && rec.implementer_review?.submitted_at !== null) ||
            (props.variant === 'clinical' && rec.clinical_review?.submitted_at !== null);
    }
    
    if (combinedChanges.length === 0) return null;

    return (
        <TableContainer style={{
            backgroundColor: 'white',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: theme.palette.border.main,
        }}>
            <Table>
                <TableHead>
                    <TableCell />
                    <TableCell><strong>Item</strong></TableCell>
                    <TableCell><strong>Item ID</strong></TableCell>
                    <TableCell><strong>Requested Optimization</strong></TableCell>
                    <TableCell style={{ textAlign: 'center' }}><strong>Open</strong></TableCell>
                    <TableCell style={{ textAlign: 'center' }}><strong>Hold</strong></TableCell>
                    <TableCell style={{ textAlign: 'center' }}><strong>New Open</strong></TableCell>
                    <TableCell style={{ textAlign: 'center' }}><strong>New Hold</strong></TableCell>
                    <TableCell style={{ textAlign: 'end' }}><strong>Review Status</strong></TableCell>
                </TableHead>
                { combinedChanges.map((rec, index) => {
                    return (
                        <StaffReviewItemEntry
                            key={rec.id}
                            index={index}
                            item={props.review.items[rec.item.category]?.find((item) => item.id === rec.item.id) ?? rec.item}
                            recommendation={rec}
                            clinical_review={rec.clinical_review}
                            implementer_review={rec.implementer_review}
                            variant={props.variant}
                            handleUpdate={props.handleUpdate}
                            disabled={isRecReadOnly(rec)}
                            selectedItem={selectedItem}
                            setSelectedItem={setSelectedItem}
                        />
                    );
                })}
            </Table>
        </TableContainer>
    );
}

export default StaffReviewChangesOnlyView;
